import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NgxQRCodeModule } from '@jonyadamit/ngx-qrcode-ivy';
import { NgbAccordionModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { LaddaModule } from 'angular2-ladda';
import { UsernamelessModalComponent } from './methods/fido/usernameless-modal/usernameless-modal.component';
import { SecondFaModal } from './second-fa-modal/second-fa-modal';
import { EnrollmentComponent } from './enrollment.component';
import { BaseComponent } from './methods/base/base.component';
import { PasswordComponent } from './methods/password/password.component';
import { PasscodeEmailComponent } from './methods/passcode-email/passcode-email.component';
import { PasscodeSmsComponent } from './methods/passcode-sms/passcode-sms.component';
import { StaticCodeComponent } from './methods/static-code/static-code.component';
import { SoftTokenComponent } from './methods/soft-token/soft-token.component';
import { HardwareTokenComponent } from './methods/hardware-token/hardware-token.component';
import { FidoComponent } from './methods/fido/fido.component';
import { YubikeyComponent } from './methods/yubikey/yubikey.component';

@NgModule({
  declarations: [
    SecondFaModal,
    UsernamelessModalComponent,
    EnrollmentComponent,
    BaseComponent,
    PasswordComponent,
    PasscodeEmailComponent,
    PasscodeSmsComponent,
    StaticCodeComponent,
    SoftTokenComponent,
    HardwareTokenComponent,
    FidoComponent,
    YubikeyComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgxQRCodeModule,
    TranslateModule,
    NgbModule,
    NgbAccordionModule,
    LaddaModule,
    NgSelectModule
  ],
  exports: [
    EnrollmentComponent,
    SoftTokenComponent,
    FidoComponent,
    NgbAccordionModule]
})

export class EnrollmentModule { }
